import React, { useEffect } from 'react';

import Spinner, { SpinnerOverlayContent } from 'Components/Spinner/Spinner';
import history from 'customHistory';
import { RegApi } from 'BackEnd/API';
import { log } from 'common/utils/logging.util';
import routes from 'common/constants/routing.constants';

export const ConfirmPassResetPage = () => {
  useEffect(() => {
    const query = new URLSearchParams(window?.location.search);
    const code = query.get('code');
    const verifyID = query.get('confirm');
    const passwordResetEmailSent = query.get('passwordReset');
    const err = query.get('err');
    if (verifyID && code) {
      RegApi.confirmResetPassword({ code, verifyID })
        .then(() => {
          history.push(routes.auth.confirmPassReset.postConfirm.path);
        })
        .catch((err) => {
          console.log(err, 'err');
          log(
            `verifying password reset failed for verifyID ${verifyID} code ${code}`,
            'error',
          );
        });
    } else if (passwordResetEmailSent) {
      window.parent.postMessage('rw_redir_mail_sent', '*');
    } else {
      history.push(`/confirm-email?err=${err}`);
    }
  }, []);

  return (
    <SpinnerOverlayContent>
      <Spinner />
    </SpinnerOverlayContent>
  );
};
